import styled from 'styled-components';

export const Wraper = styled.div`
  width: 26rem;
  border: 2px solid #e8e9f1;
  border-color: ${({active}) => (active ? '#357EDD' : '#e8e9f1')};
  border-radius: 4px;
  margin: 0rem 0.5rem;
  padding: 1.5rem;
  cursor: pointer;
  position: relative;
  background-color: ${({active}) => (active ? '#f9fafc' : '#ffff')};
  :hover {
    background-color: #f9fafc;
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  @media (max-width: 1028px) {
    margin: 0.5rem 2rem;
    order: ${({order}) => {
      switch (order) {
        case 0:
          return '2';
        case 1:
          return '1';
        case 2:
          return '3';
      }
    }};
  }
  @media (max-width: 450px) {
    width: 22rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SingleFeature = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: start;

  img {
    margin-left: 0.8rem;
    width: 0.9rem;
    height: 0.9rem;
  }

  p {
    font-size: 0.875rem;
    font-weight: ${({index}) => (index !== 2 ? 'normal' : 'bold')};
    color: ${({index}) => (index !== 2 ? '#565c64' : 'black')};
    line-height: 2rem;
    margin-bottom: ${({index}) => (index !== 2 ? '1rem' : '0')};
  }
`;

export const RadioMark = styled.span`
  position: absolute;
  top: 1.5rem;
  left: 1.5rem;
  height: 25px;
  width: 25px;
  background: ${({active}) => (active ? '#357EDD' : '#ccc')};
  border-radius: 50%;
  border-width: 2px;
  :after {
    content: '';
    position: absolute;
    display: ${({active}) => (active ? 'block' : 'none')};
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
`;
